var _style, _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterInsight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#707070",
      fill: "#3b5175"
    },
    d: "M0 0h24v24H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".d{fill:#3b5175}.c,.f{fill:none}.f{stroke:#fff;stroke-linecap:round}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0 0h24m0 24H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7 6h10l-5.01 6.3Zm-2.75-.39C6.27 8.2 10 13 10 13v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6s3.72-4.8 5.74-7.39A1 1 0 0 0 18.95 4H5.04a1 1 0 0 0-.79 1.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0 0h24v24H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 10h10l-5.01 6.3Z",
    transform: "translate(-4.667 -4)",
    style: {
      opacity: 0.3,
      fill: "#3b5175"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(13 1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m18.14 3.114.001 6.053M15.113 6.14l6.054.001"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterInsight);
export default __webpack_public_path__ + "static/media/FilterInsight.97329ecec05731e2ac83cffe0c9bb1f2.svg";
export { ForwardRef as ReactComponent };